<template>
  <div class="fc-ex">
    <!-- <div class="fc-ex-title">
      Catalogue
    </div> -->
    <!-- <div class="fc-ex-type">
      <p>请选择展会</p>
      <Checkbox v-model="exType" class="checkBox">CMEF 2020</Checkbox>
    </div> -->
    <div class="fc-ex-list" v-if="exType">
      <!-- <p>Please select a category</p> -->
      <p style="color: #333" class="item">Industry Sector</p>
      <div v-if="filterCommonLoading" style="text-align: center; line-height: 100px">
        Loading...
      </div>
      <span class="return" v-if="categoryFlag && !categoryFlag2" @click="returnFirst()"
        ><i class="icon iconfont icon-xiala"></i>Back</span
      >
      <span class="return" v-if="categoryFlag2" @click="returnFirst2()"
        ><i class="icon iconfont icon-xiala"></i>Back</span
      >
      <div v-if="!categoryFlag && categoryList && categoryList.length > 0" class="list-group-item">
        <span
          v-for="(item, index) in categoryList"
          :key="'categoryList-' + index"
          class="hoverText"
          :title="item.valueEn"
          :class="activeIndex.includes(index) ? 'active' : ''"
          @click="select(item, index)"
        >
          {{ item.valueEn }}
        </span>
      </div>
      <div
       class="list-group-item"
        v-if="categoryFlag && !categoryFlag2 && categoryList2 && categoryList2.length > 0"
      >
        <span
          v-for="(item, index) in categoryList2"
          :key="'categoryList2-' + index"
          class="hoverText"
          :title="item.valueEn"
          :class="activeIndex === index ? 'active' : ''"
          @click="selectCategory(item, index)"
        >
          {{ item.valueEn }}
        </span>
      </div>
      <div v-if="categoryFlag2 && categoryList3 && categoryList3.length > 0"  class="list-group-item">
        <span
          v-for="(item, index) in categoryList3"
          :key="'categoryList3-' + index"
          class="hoverText"
          :title="item.valueEn"
          :class="activeIndex2 === index ? 'active' : ''"
          @click="selectCategory2(item, index)"
        >
          {{ item.valueEn }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  // 类别筛选
  name: "filter-common",
  props: {
    categoryList: {
      type: Array,
      default: [],
    },
    filterCommonLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      show2: false,
      exType: true,
      categoryFlag: false,
      categoryFlag2: false,
      categoryList2: [],
      categoryList3: [],
      activeIndex: [], // 使用数组来存储多个活动索引
      //   activeIndex: -1, // 二级分类对应active
      activeIndex2: -1, // 三级分类对应active
    };
  },
  components: {},
  computed: {
    ...mapGetters({}),
  },
  methods: {
    select(item, index) {
      // 判断当前索引是否已经在activeIndex数组中
      const isActive = this.activeIndex.includes(index);

      // 如果索引已经存在，则从数组中移除它；否则添加到数组中
      if (isActive) {
        this.activeIndex = this.activeIndex.filter((i) => i !== index);
      } else {
        this.activeIndex.push(index);
        // 可以在这里进行其他处理逻辑，比如更新状态或者发送请求等
      }

      console.log(this.activeIndex);
      let list = [];
      this.activeIndex.map((i) => {
        this.categoryList.map((j, jindex) => {
          if (i == jindex) {
            list.push(j.valueEn);
          }
        });
      });
      

      this.$emit("changeCategory", list);

      },

      childMethod () {
        this.activeIndex=[]
      console.log('子组件方法被调用了！');
       },

       
    selectCategory(e, index) {
      if (e.list && e.list.length > 0) {
        this.categoryFlag2 = true;
        this.categoryList3 = e.list;
      } else {
        this.activeIndex = index;
        this.$emit("changeCategory", e.id);
      }
    },
    selectCategory2(e, index) {
      this.activeIndex2 = index;
      this.$emit("changeCategory", e.id);
    },
    returnFirst() {
      this.categoryFlag = false;
      this.activeIndex = -1;
      this.$emit("changeCategory", "");
    },
    returnFirst2() {
      this.categoryFlag2 = false;
      this.activeIndex2 = -1;
      this.$emit("changeCategory", "");
    },
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 799px) {
  .fc-ex {
  background-color: #fff;
  padding-bottom: 20px;
  margin-bottom: 20px;
  &-title {
    width: 100%;
    height: 48px;
    background-color: #024c8b;
    color: #fff;
    text-align: center;
    font-size: 20px;
    line-height: 48px;
  }
  &-type {
    p {
      font-size: 16px;
      color: #024c8b;
      padding: 20px 0 10px 20px;
    }
    .checkBox {
      width: 100%;
      margin: 0 0 10px 30px;
    }
  }
  &-list {
    p {
      font-size: 16px;
      color: #024c8b;
      padding: 20px 0 0 20px;
    }
    div {
      padding: 0 6px;
      span {
        display: block;
        width: 100%;
        // height: 30px;
        font-size: 14px;
        color: #333;
        padding-left: 24px;
        cursor: pointer;
        line-height: 24px;
        // overflow: hidden;
        // text-overflow:ellipsis;
        // white-space: nowrap;
        margin: 6px 0;
        word-wrap: break-word;
        padding-right: 10px;
        &:hover {
          background-color: #edf2f7;
          color: #024c8b;
        }
      }
    }
    .return {
      color: #333;
      margin-left: 24px;
      line-height: 30px;
      cursor: pointer;
      i {
        display: inline-block;
        transform: rotate(90deg);
        -ms-transform: rotate(90deg); /* IE 9 */
        -moz-transform: rotate(90deg); /* Firefox */
        -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
        -o-transform: rotate(90deg); /* Opera */
      }
    }
    .active {
      background-color: #edf2f7;
      color: #024c8b;
    }
  }
}
}
@media (max-width: 799px) {

  .item{
          font-family: PingFang-SC-Bold;
          font-size: calc(26vw/7.5);
          font-weight: bold;
          font-stretch: normal;
          line-height: calc(20vw/7.5);
          letter-spacing: 0px;
          color: #333333;
          margin: calc(20vw/7.5) 0 calc(26vw/7.5);
        }
  .list-group-item{
          display: flex;
          flex-wrap: wrap;
          .hoverText{
            padding: 0 calc(40vw/7.5) !important;
            margin: 0 calc(7.5vw/7.5) calc(20vw/7.5) !important;
            // height: calc(58vw/7.5);
            line-height: calc(58vw/7.5);
            background-color: #f5f5f5;
            border-radius: 5px;
            font-family: PingFang-SC-Regular;
            font-size: calc(26vw/7.5);
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }
          .active{
            background-color: #024c8b;
            color: #fff;
          }
        }
}

</style>
